
export default {
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      anchorHovered: false,
    }
  },
  computed: {
    styledObject() {
      return {
        'underline-amber': this.blok.underline_color === 'amber',
        'underline-blue': !this.blok.underline_color,
        disable: this.blok?.disable_hover,
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      const anchorTags = this.$refs.richText?.querySelectorAll('a')
      if (anchorTags?.length) {
        anchorTags.forEach((el) => {
          el.addEventListener('mouseenter', () => {
            this.$refs.richText.classList.add('hovered')
          })
          el.addEventListener('mouseleave', () => {
            this.$refs.richText.classList.remove('hovered')
          })
        })
      }
    })
  },
  methods: {
    richTextToHtml(field) {
      return this.$storyapi.richTextResolver.render(field)
    },
  },
}
